// Registry of impression targets. Source of truth:
// AnalyticsInstrumentation/schemas/apps/mtag/values/mtag_impression_event.json — which
// currently sanctions exactly one impression.
//
// `element` was dropped from the schema, so it is no longer sent; `component` and
// `section` are still declared and keep carrying the legacy context/feature values.
type ImpressionConfig = {
  impression_type: string
  legacy_interaction_context: string
  legacy_interaction_feature: string
}

export const impressions = {
  already_sampled_interstitial: {
    impression_type: 'sku_already_sampled',
    legacy_interaction_context: 'popup_modal',
    legacy_interaction_feature: 'already_sampled_interstitial',
  },
} satisfies Record<string, ImpressionConfig>

export type ImpressionId = keyof typeof impressions

export function getImpressionById(id: string): ImpressionConfig | undefined {
  return impressions[id as ImpressionId]
}
